export const PublicPreReserveUrl = {
  // Create PreReserve
  CreatePreReserve: '/PreReserve/PreReserveCommand/CreatePreReservePublic',
}
